module.exports = __webpack_public_path__ + "static/media/intelligentappdesktop.58404f49.gif";